import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export const copy = (props) => {
  return <ContentCopyIcon {...props} />;
};
